<template>
  <div id="literature-cart" class="cart-wrapper">
    <span class="in-cart">

      <span class="cart-icon" @click="toggle=!toggle"></span>

      <span class="cart-number">
        {{ cart.length }}
      </span>

      <span class="cart-items" v-if="toggle">

      <div v-if="!cart.length" class="cart-is-empty" >
        <p>No items in cart</p>
      </div>

      <div v-else class="close-cart">
        <a href="#" @click.prevent="toggle=!toggle"></a>
      </div>

      <div v-for="item in cart"
           :key="item.id"
           class="cart-item"
           @click="() => itemRemoveHandler(item.id)"
      >
        <div class="item-title">{{ item.title }}</div>
        <div class="item-quantity"><span>Qty: </span>{{ item.quantity }}</div>
      </div>

      <a href="#stage" class="place-request"
         v-if="cart.length > 0"
         @click.prevent="nextHandler"
      >
        Place Request
      </a>

      </span>
    </span>
  </div>
</template>

<script>

  export default {
    name: "LiteratureCart",
    props: {
      cart: {
        type: Array,
        default: [],
      },
      nextHandler: {
        type: Function,
        default: () => {}
      },
      itemRemoveHandler: {
        type: Function,
        default: (id) => {}
      }
    },
    data() {
      return {
        toggle: false,
      }
    },

  }
</script>
